import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FollowButton } from '@periscopes/general/FollowButton';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';
import { Space, Tooltip } from 'antd';
import { useCurrentUser, useFeatureFlag, useGlobalSelect } from '@hooks';
export const BulkFollowButtons = () => {
    const { removeSelection, getGlobalSelection, globalSelection } = useGlobalSelect();
    const followableSelection = getGlobalSelection({ excludeTypes: [SonarObjectType.SalesforceReport] });
    const followerEnabled = useFeatureFlag(FeatureFlag.Followers);
    const { isReadOnly } = useCurrentUser();
    const { followed, unfollowed } = useUpdateFollowing(followableSelection);
    const handleOnClick = () => {
        removeSelection({ selections: [] });
    };
    if (!followerEnabled || isReadOnly) {
        return null;
    }
    return (React.createElement(Space, null,
        React.createElement(FollowButton, { onClick: handleOnClick, sonarObjectIds: followed, type: 'unfollow' }),
        React.createElement(Tooltip, { open: followableSelection.length < globalSelection.length ? undefined : false, placement: 'bottom', title: COPY_SPECIFIC.REPORTS_CANNOT_BE_FOLLOWED },
            React.createElement("div", null,
                React.createElement(FollowButton, { onClick: handleOnClick, sonarObjectIds: unfollowed, type: 'follow' })))));
};
